import {
    MediaSource as MediaSourceBase,
    MediaSourceInitialDisplayFile,
    MediaSourceVideoFile,
} from "cloud-core/media/MediaSource";
import { ImportMetadataResults } from "../../views/import/components/importWizard/pages/MetadataEntryPage/MetadataEntryPage";
import { Milliseconds } from "../../utilities/numerics";
import { MediaSourceWithExtras } from "../../store/media/MediaItems";

export const MEDIASOURCE_VIDEO_DEFAULT_FRAMERATE = 25;

export function calculateFramePeriod(video: MediaSourceInitialDisplayFile | undefined): Milliseconds {
    return 1000 / (video?.frameRate ?? MEDIASOURCE_VIDEO_DEFAULT_FRAMERATE);
}

export function sortMediaSources(a: MediaSource, b: MediaSource) {
    // Latest media sources first
    return b.createdAt - a.createdAt;
}

export function getDisplayVideoAtTimestamp(
    mediaSource: MediaSourceWithExtras,
    timestamp: Milliseconds,
): MediaSourceVideoFile | undefined {
    const videoTime = timestamp - mediaSource.startsAt;

    return mediaSource.displayFiles.find((file) => {
        return file.startsAt <= videoTime && file.startsAt + file.duration >= videoTime;
    });
}

export function getDisplayVideoAtTimestampIndex(mediaSource: MediaSourceWithExtras, timestamp: Milliseconds): number {
    return mediaSource.displayFiles.findIndex((file) => {
        return file.startsAt <= timestamp && file.startsAt + file.duration >= timestamp;
    });
}

export type MediaSource = MediaSourceBase<Milliseconds>;

export type IntegrationMediaSource = Omit<
    MediaSource,
    "mediaId" | "startsAt" | "organisationId" | "tags" | "metadata"
> & {
    integrationId: string;
    integrationMediaId: string;
    preview: {
        type: "url" | "file";
        source: string;
    };
    video: {
        fileSize: number;
        mimeType: string;
        format: string;
        fileId: string;
        width: number;
        height: number;
        frameRate: number;
    };
};

export interface AddMediaSourceRequestBody
    extends Omit<
        MediaSource,
        | "mediaId"
        | "createdAt"
        | "updatedAt"
        | "organisationId"
        | "files"
        | "attachmentCount"
        | "tags"
        | "originalSource"
        | "createdBy"
        | "thumbnails"
    > {
    metadata: ImportMetadataResults;
}
